<mat-toolbar class="top-0 left-0 right-0 !bg-white border-bottom border-2 border-gray-200 flex justify-between">
  <div class="flex flex-row gap-2">
    @if (showHamburger()) {
      <app-pan-button class="mr-2" fill="clear" icon="menu" (click)="hamburgerClicked.emit()"></app-pan-button>
    }

    <app-company-logo [routeTo]="['/home']"></app-company-logo>
  </div>

  @if (isLoggedIn() && showUserInfo()) {
    <!-- non-mobile -->
    <div class="hidden sm:block">
      <span class="mr-20">
        <app-pan-button fill="clear" [matMenuTriggerFor]="menu">
          {{ user() }}
        </app-pan-button>
      </span>
      <mat-menu #menu="matMenu">
        <button [routerLink]="['/home', 'user-preferences']" target="_blank" mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>User Preferences</span>
        </button>

        @if (debug.canShowDebug()) {
          <button mat-menu-item (click)="debug.toggleDebug()">
            <mat-icon>bug_report</mat-icon>
            <span>Toggle Debug</span>
          </button>
        }
      </mat-menu>
      <a panButton [routerLink]="[logoutRoute()]"> Logout </a>
    </div>

    <!-- mobile -->
    <div class="block sm:hidden">
      <app-pan-button fill="clear" icon="settings" class="mobile-icon-button" [matMenuTriggerFor]="mobileMenu"> </app-pan-button>
      <mat-menu #mobileMenu="matMenu">
        <div mat-menu-item [disabled]="true">
          {{ user() }}
        </div>

        <button [routerLink]="['/home', 'user-preferences']" target="_blank" mat-menu-item>
          <mat-icon>settings</mat-icon>
          <span>User Preferences</span>
        </button>

        @if (debug.canShowDebug()) {
          <button mat-menu-item (click)="debug.toggleDebug()">
            <mat-icon>bug_report</mat-icon>
            <span>Toggle Debug</span>
          </button>
        }

        <button mat-menu-item [routerLink]="[mobileLogoutRoute()]">
          <mat-icon>logout</mat-icon>
          Logout
        </button>
      </mat-menu>
    </div>
  }
</mat-toolbar>
